const AggressionCard = require("../../entities/Cards/AggressionCard");
const Aggressions = require("../../Constants/Aggressions/Aggressions");
const ByName = require("./ByName");

const classOf = ByName(Aggressions);

const AggressionConverter = (aggressionName, aggressionAge) =>
{
    const Class = classOf(aggressionName);
    return Class === undefined ? null : new AggressionCard(new Class(aggressionAge));
}

module.exports = AggressionConverter;
